import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'
import { IEventCollectionData } from 'meta/pages/v4/eventCollection'

type Props = {
  codes: string[]
}

type Response = { items: IEventCollectionData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { codes } = props

  const endpoint = ApiEndpoint.v4.eventCollection.bulk(codes)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
